<!--
 * @Author: wzc
 * @Date: 2021-01-26 10:51:49
 * @LastEditors: wzc
 * @LastEditTime: 2021-06-18 10:41:24
-->
<template>
  <div class="load-cont" :style="style">
    <!-- <div class="load-logo"></div> -->
    <div class="popTipDiv">
      <!-- <span class="inforTitle" v-text="popInfor.infor"></span> -->
      <div class="spinner">
        <div class="bounce1"></div>
        <div class="bounce2"></div>
        <div class="bounce3"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    zIndex: {
      type: Number,
      default: 3,
    },
  },
  computed: {
    style() {
      return `z-index: ${this.zIndex};`
    },
  },
  data() {
    return {
      popInfor: {
        infor: '加载中...',
        btnName: '加载',
      },
    }
  },
}
</script>

<style lang="scss" scoped>
.load-cont {
  position: fixed;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  /* .load-logo {
    width: 100px;
    height: 100px;
    background: url('../../assets/images/cctv_loading.gif') no-repeat center;
    background-size: 100%;
  }
  .load-info {
    height: 150px;
    line-height: 150px;
    font-size: 30px;
    color: #999999;
  } */
}

.spinner {
  width: 20vw;
  text-align: center;
}

.spinner > div {
  margin: 0 0.5vw;
  width: 2vw;
  height: 2vw;
  border-radius: 100%;
  display: inline-block;
  -webkit-animation: bouncedelay 1.4s infinite ease-in-out;
  animation: bouncedelay 1.4s infinite ease-in-out;
  /* Prevent first frame from flickering when animation starts */
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}
.spinner > div:nth-child(1) {
  /* background-color: #1b94d3; */
  background-color: rgba(235, 27, 80, 1);
}

.spinner > div:nth-child(2) {
  /* background-color: #8bc34a; */
  background-color: rgba(238, 238, 229, 1);
}

.spinner > div:nth-child(3) {
  /* background-color: #ffb74d; */
  background-color: rgba(0, 207, 183, 1);
}

.spinner .bounce1 {
  -webkit-animation-delay: -0.32s;
  animation-delay: -0.32s;
}

.spinner .bounce2 {
  -webkit-animation-delay: -0.16s;
  animation-delay: -0.16s;
}

@-webkit-keyframes bouncedelay {
  0%,
  80%,
  100% {
    -webkit-transform: scale(0);
  }
  40% {
    -webkit-transform: scale(1);
  }
}

@keyframes bouncedelay {
  0%,
  80%,
  100% {
    transform: scale(0);
    -webkit-transform: scale(0);
  }
  40% {
    transform: scale(1);
    -webkit-transform: scale(1);
  }
}
.popTipDiv {
  display: flex;
  display: -webkit-flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 20vw;
  height: 15vw;
  /* background-color: rgba(0, 0, 0, 0.2); */
  border-radius: 0.694vw;
  .inforTitle {
    display: block;
    padding: 0 5%;
    width: 100%;
    font-size: 1.388vw;
    line-height: 2.778vw;
    text-align: center;
    color: rgba(23, 48, 75, 1);
  }
}
</style>
